import requestAxios from "./requestAxios";

const cmbFunction =   {
    cmbPaises: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbPaises`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbEstados: async function (infoUs,paisId) {
      const { error, data } = await requestAxios({
        url: `ComboBox/cmbEstados?paisId=${paisId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbTipoGestion: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbTipoGestion`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbTipoValoracion: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbTipoValoracion`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbJuzgado: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbJuzgados`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbTipoValoracion: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbTipoValoracion`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbTipoJuicio: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbTipoJuicio`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    AcreditadosGestor: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/AcreditadosGestor`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbTipoComentarios: async function (infoUs) {

      const { error, data } = await requestAxios({
        url: `ComboBox/cmbTipoComentario`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    cmbEtapasDisponibles: async function (infoUs,demandaId,etapaId,exist) {
      exist=exist==null?false:true;
      const { error, data } = await requestAxios({
        url: `ComboBox/cmbEtapasDisponibles?demandaId=${demandaId}&etapaId=${etapaId}&exist=${exist}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
  };
export default cmbFunction;
